import React from "react";
import DefaultImage from "../branding/default/contact.png";

export const Service = props => {
  return (
    <div className="service text-align-center margin-bottom-1em">
      <button
        onClick={props.onClick}
        className="btn background-color-inherit mousefocus-border"
      >
        <div className="color-black service-center">
          <div className="text-align-center service-image">
            <img
              src={
                props.service.imageUrl !== ""
                  ? props.service.imageUrl
                  : DefaultImage
              }
              width="120"
              height="120"
              alt={props.text("common.call") + " " + props.service.name}
            />
          </div>
          <div className="text-align-center service-text">
            <strong aria-hidden="true">{props.service.name}</strong>
          </div>
        </div>
      </button>
    </div>
  );
};






// WEBPACK FOOTER //
// ./src/components/Service.js